<template>
	<div class="container">
		<!-- 头部 -->
		<div class="header"><img :src="require('@/assets/title.png')"></div>
		<img class="leftImg" :src="require('@/assets/left.png')">
		<img class="rightImg" :src="require('@/assets/right.png')">
		<div class="bottomImg"><img :src="require('@/assets/bottom.png')"></div>
		<!-- 左侧 -->
		<div class="leftMain">
			<leftMain></leftMain>
		</div>
		<!-- 地图 -->
		<div class="main">
			<mainMap></mainMap>
		</div>
		<!-- 右侧 -->
		<div class="rightMain">
			<rightMain></rightMain>
		</div>
	</div>
</template>


<script>
import leftMain from "./leftMain.vue";
import rightMain from "./rightMain.vue";
import mainMap from "./main.vue";
export default {
	components: { leftMain, rightMain, mainMap },
	created() {
		window.onload = function () {
			sessionStorage.clear()
		}
	}
}
</script>


<style lang="scss" scoped>
.container {
	width: 100%;
	height: 100%;
	display: flex;
	position: relative;
	background: url('../assets/gridBg.png') no-repeat;
	background-size: 100% 100%;
	.header {
		width: 100%;
		height: 80px;
		position: absolute;
		z-index: 1000;
		left: 0;
		top: 0;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.leftImg {
		height: calc(100% - 50px);
		position: absolute;
		left: 20px;
		top: 30px;
	}
	.rightImg {
		height: calc(100% - 50px);
		position: absolute;
		right: 20px;
		top: 30px;
	}
	.bottomImg {
		width: 100%;
		text-align: center;
		position: absolute;
		left: 0;
		bottom: 0;
	}
	.leftMain {
		flex: 0 0 460px;
		height: 100%;
		padding: 80px 0 70px 60px;
		box-sizing: border-box;
	}
	.main {
		flex: 1;
		height: 100%;
		padding: 80px 20px 70px 20px;
	}
	.rightMain {
		flex: 0 0 460px;
		height: 100%;
		padding: 80px 60px 70px 0;
		box-sizing: border-box;
	}
}
</style>